export const DASHBOARD_ROUTES = {
  ROOT: '',
  STUDIES: 'studies',
  SETTINGS: 'settings',
};
